var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"static":"","hide-footer":"","title":"Filtrar Serviços","body-class":"min-h-40","size":"lg","centered":"","id":"filter-service"}},[_c('filter-service')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }